import SingleModelInterface from '../../types/singleModelInterface'

export default function filterByCarModel(
    carModels: string[],
    allModels: SingleModelInterface[]
): SingleModelInterface[] {
    if (carModels.length) {
        return allModels.filter((model) =>
            carModels.includes(model.carline_name)
        )
    }

    return allModels
}
